module.exports = __webpack_public_path__ + "static/media/Group 160.570becc8.svg";